module.exports = __webpack_public_path__ + "428b2306e9c7444556058c70822d7d7c.ttf";